import request from '@/utils/request'


// 查询医院科室列表
export function listDepart(query) {
  return request({
    url: '/hospital/depart/list',
    method: 'get',
    params: query
  })
}

// 查询医院科室分页
export function pageDepart(query) {
  return request({
    url: '/hospital/depart/page',
    method: 'get',
    params: query
  })
}

// 查询医院科室详细
export function getHospitalDepart(data) {
  return request({
    url: '/hospital/depart/detail',
    method: 'get',
    params: data
  })
}

// 新增医院科室
export function addDepart(data) {
  return request({
    url: '/hospital/depart/add',
    method: 'post',
    data: data
  })
}

// 修改医院科室
export function updateDepart(data) {
  return request({
    url: '/hospital/depart/edit',
    method: 'post',
    data: data
  })
}

// 删除医院科室
export function delDepart(data) {
  return request({
    url: '/hospital/depart/delete',
    method: 'post',
    data: data
  })
}

export function importDepart(data) {
  return request({
    url: '/hospital/depart/import',
    method: 'post',
    data: data
  })
}

// 自主加减分
export function adjustDepartScore (id, changeScore) {
  const data = {
    id,
    changeScore
  }
  return request({
    url: '/hospital/depart/changeScore',
    method: 'put',
    data: data
  })
}

// 设置和取消百强科室
export function changeDepartTop100Status (id, isTop100, top100Rank) {
  const data = {
    id,
    isTop100,
    top100Rank
  }
  return request({
    url: '/hospital/depart/changeIsTop',
    method: 'put',
    data: data
  })
}

// 同步科室华歧系数
export function syncDepartScore(data = []) {
  return request({
    url: '/hospital/depart/syncDepartScore',
    method: 'put',
    data: data
  })
}

// 查询某个科室的华歧系数详情
export function getDepartScoreDetail(hospitalDepartId) {
  return request({
    url: '/hospital/departScoreDetail/detailByDepartId',
    method: 'get',
    params: { hospitalDepartId: hospitalDepartId }
  })
}
